// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"styles_cardWrapper__L_XoW","alignfull":"styles_alignfull__70Pgh"};